import { render, staticRenderFns } from "./RoomTestbankHistory.vue?vue&type=template&id=d67a6e3a&"
import script from "./RoomTestbankHistory.vue?vue&type=script&lang=js&"
export * from "./RoomTestbankHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d67a6e3a')) {
      api.createRecord('d67a6e3a', component.options)
    } else {
      api.reload('d67a6e3a', component.options)
    }
    module.hot.accept("./RoomTestbankHistory.vue?vue&type=template&id=d67a6e3a&", function () {
      api.rerender('d67a6e3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Testbank/History/RoomTestbankHistory.vue"
export default component.exports